// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subaccounts_GatewayTestTriggerInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subaccounts_GatewayTestTriggerInput — body for POST /subaccounts/webhooks/gatewaytest.
 *
 * The request must also carry a valid X-GatewayTest-Signature header (HMAC-SHA256
 * of the raw body, keyed by the gatewaytest webhook_secret) — verified by
 * GatewayTestPlatformGateway::verifyWebhook() BEFORE this contract runs.
 *
 * Subscription events (sub_id required):
 *   event_type  — SUBSCRIPTION_CREATED, PAYMENT_CONFIRMED,
 *                 PAYMENT_OVERDUE, SUBSCRIPTION_INACTIVATED
 *   sub_id      (string) — provider_subscription_id to target
 *
 * One-off charge events (charge_id required, sub_id ignored):
 *   event_type  — ONE_OFF_CHARGE_CONFIRMED, ONE_OFF_CHARGE_FAILED
 *   charge_id   (string) — the provider charge id to target
 *
 * Common optional fields:
 *   value_cents        (int)    — amount in cents (default 0)
 *   provider_charge_id (string) — legacy alias for charge_id (subscription path)
 *   paid_at            (string) — ISO date YYYY-MM-DD (default today)
 *   external_reference (string) — provider pass-through stored on the event payload
 */
import { registerContract } from './validate'

export interface Subaccounts_GatewayTestTriggerInput {
event_type: string
sub_id?: string
charge_id?: string
value_cents?: number
provider_charge_id?: string
paid_at?: string
external_reference?: string
}

registerContract('Subaccounts_GatewayTestTriggerInput', {
  event_type:         { type: 'string',  required: true },
  sub_id:             { type: 'string',  required: false },
  charge_id:          { type: 'string',  required: false },
  value_cents:        { type: 'number',  required: false },
  provider_charge_id: { type: 'string',  required: false },
  paid_at:            { type: 'string',  required: false },
  external_reference: { type: 'string',  required: false },
})
